// LOINC API service
import { BaseAPI } from './base';
import type {
  LoincTerm,
  LoincSearchParams,
  LoincSearchResult,
  LoincServiceStats,
  LoincValidationRequest,
  LoincValidationResult,
} from '../../types/loinc';

class LoincAPI extends BaseAPI {
  async searchTerms(params: LoincSearchParams): Promise<LoincSearchResult> {
    const searchParams = new URLSearchParams();
    
    if (params.query) searchParams.append('query', params.query);
    if (params.category) searchParams.append('category', params.category);
    if (params.language) searchParams.append('language', params.language);
    if (params.limit) searchParams.append('limit', params.limit.toString());
    if (params.offset) searchParams.append('offset', params.offset.toString());

    const url = params.category === 'gynob' 
      ? '/api/loinc/search/gynob'
      : '/api/loinc/search';

    return this.request<LoincSearchResult>({
      method: 'GET',
      url: `${url}?${searchParams.toString()}`,
    });
  }

  async getTermByCode(loincCode: string): Promise<LoincTerm> {
    return this.request<LoincTerm>({
      method: 'GET',
      url: `/api/loinc/code/${loincCode}`,
    });
  }

  async getTermTranslation(loincCode: string, language: string): Promise<LoincTerm> {
    return this.request<LoincTerm>({
      method: 'GET',
      url: `/api/loinc/code/${loincCode}/translation/${language}`,
    });
  }

  async validateCodes(request: LoincValidationRequest): Promise<LoincValidationResult> {
    return this.request<LoincValidationResult>({
      method: 'POST',
      url: '/api/loinc/validate',
      data: request,
    });
  }

  async getStats(): Promise<LoincServiceStats> {
    return this.request<LoincServiceStats>({
      method: 'GET',
      url: '/api/loinc/stats',
    });
  }

  async getHealth(): Promise<{ status: string; timestamp: string }> {
    return this.request<{ status: string; timestamp: string }>({
      method: 'GET',
      url: '/api/loinc/health',
    });
  }

  async getConfig(): Promise<Record<string, unknown>> {
    return this.request<Record<string, unknown>>({
      method: 'GET',
      url: '/api/loinc/config',
    });
  }

  async filterGynobTerms(params?: { limit?: number; offset?: number }): Promise<LoincSearchResult> {
    const searchParams = new URLSearchParams();
    
    if (params?.limit) searchParams.append('limit', params.limit.toString());
    if (params?.offset) searchParams.append('offset', params.offset.toString());

    return this.request<LoincSearchResult>({
      method: 'GET',
      url: `/api/loinc/filter/gynob?${searchParams.toString()}`,
    });
  }
}

export const loincAPI = new LoincAPI();
